import { useEffect, useRef, useState } from 'react';
import HeroSection from './components/HeroSection';
import FocusAreasSection from './components/FocusAreasSection';
import ContactSection from './components/ContactSection';
import InteractiveBackground from './components/InteractiveBackground';

export default function HomePage() {
  return (
    <div className="relative min-h-screen bg-white overflow-hidden">
      <InteractiveBackground />
      
      <div className="relative z-10">
        <HeroSection />
        <FocusAreasSection />
        <ContactSection />
      </div>
    </div>
  );
}
